"use client";

import { useEffect, useState } from "react";

import { useShell } from "@/components/shell/shell-context";
import { api } from "@/lib/api/client";
import type { OnpageRequirements } from "@/lib/api/types";

/** Datenquellen, Grenzen und geschätzter Verbrauch der Onpage-Analyse. Lädt neu, wenn sich Verbindungen ändern. */
export function useOnpageRequirements(projectId: number) {
  const { connections } = useShell();
  const [requirements, setRequirements] = useState<OnpageRequirements | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api<OnpageRequirements>(`/api/onpage/requirements?project_id=${projectId}`)
      .then((next) => {
        if (cancelled) return;
        setRequirements(next);
        setFailed(false);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [projectId, connections]);

  return { requirements, failed };
}
